import PropTypes from "prop-types"
import { Helmet } from "react-helmet-async"

import OccasionGrid from "components/occasion-grid"

import InfoLayout from "./info-layout"
import InfoLayoutNew from "./info-layout-new"
import InfoLayoutRebrand from "./info-layout-rebrand"
import NoInfoLayout from "./no-info-layout"

const InfoRouteWrapper = ({
  children,
  description,
  newLayout,
  rebrand,
  removeLayout,
  showCta,
  title,
  ...props
}) => {
  const Comp = newLayout
    ? InfoLayoutNew
    : rebrand
      ? InfoLayoutRebrand
      : removeLayout
        ? NoInfoLayout
        : InfoLayout

  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>{title}</title>
        <meta content={title} property="og:title" />
        {description && <meta content={description} name="description" />}
        {description && (
          <meta content={description} property="og:description" />
        )}
      </Helmet>
      <Comp title={title} {...props}>
        {children}
      </Comp>
      {showCta && <OccasionGrid />}
    </>
  )
}

InfoRouteWrapper.propTypes = {
  children: PropTypes.node,
  description: PropTypes.string,
  newLayout: PropTypes.bool,
  rebrand: PropTypes.bool,
  removeLayout: PropTypes.bool,
  showCta: PropTypes.bool,
  title: PropTypes.string,
}

export default InfoRouteWrapper
